import { isNonNullableObject } from "@knyt/artisan";
/**
 * Determines whether the input is a {@link ReactiveControllerHost}.
 *
 * @public
 */
export function isReactiveControllerHost(value) {
    return (isNonNullableObject(value) &&
        "addController" in value &&
        typeof value.addController === "function" &&
        "removeController" in value &&
        typeof value.removeController === "function" &&
        "requestUpdate" in value &&
        typeof value.requestUpdate === "function");
}
